import apiService from "./apiService";
import { ENDPOINTS } from "../Endpoints";

class BookingService {
  async getBookings(params = {}) {
    return apiService.get(ENDPOINTS.BOOKING.LIST, params);
  }

  async getPendingAssistantBookings(page = 1, limit = 20) {
    return this.getBookings({
      status: "pending_assistant_action",
      page,
      limit,
    });
  }

  async getMyBookings(params = {}) {
    return apiService.get(ENDPOINTS.BOOKING.MINE, params);
  }

  async cancelBooking(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for cancellation.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/cancel`,
      payload
    );
  }

  async initPaystackPayment(payload = {}) {
    return apiService.post(ENDPOINTS.BOOKING.PAYSTACK_INIT, payload);
  }

  async initBankTransfer(payload = {}) {
    return apiService.post(ENDPOINTS.BOOKING.BANK_TRANSFER_INIT, payload);
  }

  async verifyPaystackPayment(reference) {
    if (!reference) {
      throw new Error("Payment reference is required for verification.");
    }
    return apiService.get(
      `${ENDPOINTS.BOOKING.PAYSTACK_VERIFY}/${reference}`
    );
  }

  async acceptBooking(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for acceptance.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/accept`,
      payload
    );
  }

  async rejectBooking(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for rejection.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/reject`,
      payload
    );
  }

  async getBookingById(id, params = {}) {
    if (!id) {
      throw new Error("Booking ID is required.");
    }
    return apiService.get(`${ENDPOINTS.BOOKING.DETAIL}/${id}`, params);
  }

  async assistantArrival(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for marking arrival.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/arrival`,
      payload
    );
  }

  async startTrip(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for starting trip.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/start-trip`,
      payload
    );
  }

  async completeTrip(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for completing trip.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/complete-trip`,
      payload
    );
  }

  // Traveller side of the two-party handshake. The trip only starts, and the
  // assistant's money is only released, once both parties have confirmed.
  async confirmTripStart(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for confirming trip start.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/confirm-start`,
      payload
    );
  }

  async confirmTripEnd(id, payload = {}) {
    if (!id) {
      throw new Error("Booking ID is required for confirming trip end.");
    }
    return apiService.patch(
      `${ENDPOINTS.BOOKING.ACTIONS}/${id}/confirm-end`,
      payload
    );
  }
}

const bookingService = new BookingService();

export default bookingService;
